import { useCallback } from 'react';
import { closeTopLayer } from './useCloseOnBack';
import { useGoBack } from './useGoBack';

/** «Назад» жестом или системной кнопкой: сначала открытая шторка, потом экран */
export function useBackAction() {
  const goBack = useGoBack();

  return useCallback(() => {
    if (!closeTopLayer()) goBack();
  }, [goBack]);
}
